import React from 'react';

const formatSeparatorDate = (date) => {
  if (!date) return '';
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const targetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffTime = today.getTime() - targetDate.getTime();
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    return 'Today';
  }
  if (diffDays === 1) {
    return 'Yesterday';
  }
  
  const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
  const day = date.getDate();
  const month = date.getMonth() + 1;
  
  if (diffDays >= 365) {
    const year = date.getFullYear();
    return `${weekday} (${day}/${month}/${year})`;
  } else {
    return `${weekday} (${day}/${month})`;
  }
};

export const DateSeparator = ({ date }) => {
  const formatted = formatSeparatorDate(date);
  if (!formatted) return null;

  return (
    <div className="flex items-center justify-center my-6 px-6 select-none">
      {/* Left solid crisp line */}
      <div className="flex-1 border-t border-gray-200/60 dark:border-zinc-800/40"></div>
      
      {/* Center Text */}
      <span className="text-[10px] md:text-[10.5px] font-normal text-gray-400/80 dark:text-zinc-500/80 mx-4 tracking-normal">
        {formatted}
      </span>
      
      {/* Right solid crisp line */}
      <div className="flex-1 border-t border-gray-200/60 dark:border-zinc-800/40"></div>
    </div>
  );
};

export default DateSeparator;
